// Close private event enquiry sidebar when scrolled away
export function privateEventClose() {
  const privateEventEnquiry = document.querySelector(
    ".m-private-event-enquiry",
  );

  if (privateEventEnquiry) {
    const body = document.body;

    new Waypoint({
      element: privateEventEnquiry,
      handler: function (direction) {
        if (direction === "up") {
          body.classList.remove("private-event-open");
        }
      },
      offset: "100%",
    });

    new Waypoint({
      element: privateEventEnquiry,
      handler: function (direction) {
        if (direction === "down") {
          body.classList.remove("private-event-open");
        }
      },
      offset: function () {
        return -this.element.clientHeight;
      },
    });
  }
}

// Toggle open/close private event enquiry sidebar
export function privateEventToggle() {
  document.body.classList.add("private-event-closed");

  const privateEventEnquiry = document.querySelectorAll(
    ".m-private-event-enquiry",
  );

  if (privateEventEnquiry.length > 0) {
    const body = document.body;

    document.addEventListener("click", function (event) {
      const buttons = document.querySelectorAll(
        ".m-private-event-enquiry button",
      );
      const sidebar = document.querySelector(".private-event-enquiry-sidebar");
      const close = sidebar.querySelector(".c-close");

      buttons.forEach((button) => {
        if (event.target === button) {
          body.classList.remove("private-event-closed");
          body.classList.add("private-event-open");
        }
      });

      if (event.target === close) {
        body.classList.remove("private-event-open");
        body.classList.add("private-event-closed");
      }

      if (
        !Array.from(buttons).includes(event.target) &&
        body.classList.contains("private-event-open") &&
        !sidebar.contains(event.target)
      ) {
        body.classList.remove("private-event-open");
        body.classList.add("private-event-closed");
      }
    });
  }
}
